const ChannelTypes = {
  DISPLAY: 'display',
  SOCIAL: 'social',
  VIDEO: 'video',
  MOBILE: 'mobile',
  SEARCH: 'search',
  EMAIL: 'email',
  GHOST: 'ghost',
  GDN: 'gdn',
  VIDEO_ADWORDS: 'video-adwords',
  DISPLAY_ADWORDS: 'display-adwords',
  AD_SERVER: 'ad_server',
  NATIVE: 'native',
  ADDRESSABLE_TV: 'addressable_tv',
  OFFLINE_TV: 'offline_tv',
  DOOH: 'dooh',
  OOH: 'ooh',
  DMP: 'dmp',
  DEM: 'dem',
  PUBLISHER: 'publisher',
  OFFLINE_RADIO: 'offline_radio',
  NETWORK: 'network',
  PROGRAMMATIC_RADIO: 'programmatic_radio',
  DIRECT: 'direct',
  BRAND_SAFETY: 'brand_safety',
  CHAT_BOT: 'chatbot',
  DSP: 'dsp',
  INFLUENCER_MARKETING: 'influencer_marketing',
  BRANDED_CONTENT: 'branded_content',
  WEB_ANALYTICS: 'web_analytics',
  ORGANIC: 'organic',
  AFFILIATION: 'affiliation',
  META_SEARCH: 'metasearch',
  PAY_TV: 'pay_tv',
  PROMOCODE: 'promocode',
  MEMBER_GET_MEMBER: 'member_get_member',
  EVENTS: 'events',
  NEWSPAPER: 'newspaper',
  MAGAZINE: 'magazine',
  CINEMA: 'cinema',
  DIRECT_MEDIA: 'direct_media',
  PAID_PROGRAMMATIC: 'paid_programmatic',
  RETAIL: 'retail',
};

export default ChannelTypes;
